import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { XmppService } from 'src/app/core/services/xmpp.service';


@Component({
    selector: 'app-logout',
    host: { 'custom-attr': 'unique-id' },
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
    standalone: false
})
export class LogoutComponent {
  // constructor(
  //   public dialogRef: MatDialogRef<LogoutComponent>,
  //   @Inject(MAT_DIALOG_DATA) public data: any,
  //   private router: Router // Inject MAT_DIALOG_DATA if needed
  // ) {}
  constructor(private router:Router,
    private xmppService: XmppService,
  ){}

  // onCancel(): void {
  //   this.dialogRef.close(false);
  // }

  // onConfirm(): void {
  //   this.dialogRef.close(true);
  // }
  logout() {
  // ✅ Cleanly close the XMPP WebSocket connection
  this.xmppService.disconnect();

  // ...your existing logout logic (clear localStorage, navigate to /login, etc.)
  localStorage.clear();
  // this.router.navigate(['/login']);
}
}
